module.exports = __webpack_public_path__ + "static/media/nnft.11d32c8c.jpg";